import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {reactive, watch} from 'vue'
import PrioritySelect from "@/components/inputs/PrioritySelect.vue";
import TimepickerSmall from "@/components/inputs/TimepickerSmall.vue";
import StateSelect from "@/components/inputs/StateSelect.vue";
import {Order} from "@/types/Order";
import {useGlobalSetting} from "@/lib/utils";

const ss = "2025-05-22T15:00:00"


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderInformationDialog',
  props: /*@__PURE__*/_mergeModels({
  readonly: {
    type: Boolean,
    default: false
  }
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

const record = _useModel<Order>(__props, "modelValue");

const props = __props

//const emit = defineEmits(["change"])

watch(record, newVal => {
  useGlobalSetting().hasChanged = true;
  //emit('change', newVal)
})

/*const form = ref({
  id: '',
  akz: '',
  author: '',
  title: '',
  description: '',
  prio: '',
  sollStart: '',
  sollDauer: '',
  state: '',
  duration: '',
  reply: '',
})*/

const form = reactive(record)

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "pa-0",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: form.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.title) = $event)),
                class: _normalizeClass(__props.readonly ? 'custom-readonly' : ''),
                readonly: __props.readonly,
                label: "Titel",
                title: "Titel",
                variant: _unref(useGlobalSetting)().globalTextVariant
              }, null, 8, ["modelValue", "class", "readonly", "variant"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_textarea, {
                modelValue: form.description,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.description) = $event)),
                class: _normalizeClass(__props.readonly ? 'custom-readonly' : ''),
                readonly: __props.readonly,
                label: "Beschreibung",
                "no-resize": "",
                title: "Beschreibung",
                variant: _unref(useGlobalSetting)().globalTextVariant
              }, null, 8, ["modelValue", "class", "readonly", "variant"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            class: "d-flex flex-column",
            cols: "12",
            sm: "4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: form.id,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.id) = $event)),
                class: _normalizeClass(__props.readonly ? 'custom-readonly' : ''),
                readonly: __props.readonly,
                label: "ID",
                title: "ID",
                variant: _unref(useGlobalSetting)().globalTextVariant
              }, null, 8, ["modelValue", "class", "readonly", "variant"]),
              _createVNode(_component_v_text_field, {
                modelValue: form.author,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.author) = $event)),
                class: _normalizeClass(__props.readonly ? 'custom-readonly' : ''),
                readonly: __props.readonly,
                label: "Autor",
                title: "Autor",
                variant: _unref(useGlobalSetting)().globalTextVariant
              }, null, 8, ["modelValue", "class", "readonly", "variant"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "d-flex flex-column",
            cols: "12",
            sm: "4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: form.asset_id,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.asset_id) = $event)),
                class: _normalizeClass(__props.readonly ? 'custom-readonly' : ''),
                readonly: __props.readonly,
                label: "AKZ",
                title: "AKZ",
                variant: _unref(useGlobalSetting)().globalTextVariant
              }, null, 8, ["modelValue", "class", "readonly", "variant"]),
              _createVNode(PrioritySelect, {
                modelValue: form.priority,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.priority) = $event)),
                readonly: __props.readonly,
                variant: _unref(useGlobalSetting)().globalTextVariant
              }, null, 8, ["modelValue", "readonly", "variant"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "4"
          }, {
            default: _withCtx(() => [
              _createVNode(StateSelect, {
                modelValue: form.state,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.state) = $event)),
                class: _normalizeClass(__props.readonly ? 'custom-readonly' : ''),
                readonly: __props.readonly,
                variant: _unref(useGlobalSetting)().globalTextVariant
              }, null, 8, ["modelValue", "class", "readonly", "variant"]),
              _createVNode(TimepickerSmall, {
                modelValue: form.scheduled_duration,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.scheduled_duration) = $event)),
                readonly: __props.readonly,
                label: "Solldauer"
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: ss,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((ss) = $event)),
                class: _normalizeClass(__props.readonly ? 'custom-readonly' : ''),
                readonly: __props.readonly,
                label: "Sollstart",
                title: "Sollstart",
                type: "datetime-local",
                variant: _unref(useGlobalSetting)().globalTextVariant
              }, null, 8, ["class", "readonly", "variant"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: form.scheduled_end,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.scheduled_end) = $event)),
                class: _normalizeClass(__props.readonly ? 'custom-readonly' : ''),
                readonly: __props.readonly,
                label: "Sollende",
                title: "Sollende",
                type: "datetime-local",
                variant: _unref(useGlobalSetting)().globalTextVariant
              }, null, 8, ["modelValue", "class", "readonly", "variant"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})